import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-selection-step-20676" }
const _hoisted_2 = { class: "plan-selection-step-20676__cards" }

import type { BillingView, PlanView } from '@/models/billing'

import PlanCard20676 from '@/app/components/onboarding/plan-card-capture/PlanCard20676.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'PlanSelectionStep20676',
  props: {
    billing: {},
    selectedPlan: {}
  },
  emits: ["update:selectedPlan", "continue", "skip"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PlanCard20676, {
        plan: __props.billing.annualPlan,
        billing: __props.billing,
        selected: __props.selectedPlan.id === 'plan_annual',
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:selectedPlan', __props.billing.annualPlan)))
      }, null, 8, ["plan", "billing", "selected"]),
      _createVNode(PlanCard20676, {
        plan: __props.billing.monthlyPlan,
        billing: __props.billing,
        selected: __props.selectedPlan.id === 'plan_monthly',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('update:selectedPlan', __props.billing.monthlyPlan)))
      }, null, 8, ["plan", "billing", "selected"])
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "plan-selection-step-20676__info" }, " Enjoy 5 days of unlimited access. We'll remind you before your trial ends. ", -1)),
    _createElementVNode("button", {
      type: "button",
      class: "plan-selection-step-20676__continue btns btns--large",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('continue')))
    }, " Continue "),
    _createElementVNode("button", {
      type: "button",
      class: "plan-selection-step-20676__skip",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('skip')))
    }, " Skip for now ")
  ]))
}
}

})